// extracted by mini-css-extract-plugin
export default {"topControls":"HjAwT2","back":"EDOA9C","skip":"LDdvAz"};